<template>
  <div>
    <div v-if="showBlank">
      <img src="/static/no_plag_detected.png" alt="No Plagiarism Detected" />
    </div>
    <table v-else>
      <tr>
        <td style="width: 30%; vertical-align: top">
          <table style="margin-bottom: 8px">
            <tr>
              <td><div class="red-square"></div></td>
              <td>
                <span style="font-weight: bold; margin-left: -10px"
                  ><b>> 40% overlap in text</b></span
                >
              </td>
            </tr>
            <tr>
              <td><div class="yellow-square"></div></td>
              <td>
                <span style="font-weight: bold"
                  >&nbsp;25 - 39% overlap in text</span
                >
              </td>
            </tr>
          </table>
          <div style="text-align: left">
            Based on Latest Submission<br /><br />
          </div>
          <div style="overflow-y: scroll; height: 740px">
            <div v-for="red in redPlags" :key="red.id" @click="select(red)">
              <table>
                <tr>
                  <td>
                    <div
                      :class="
                        selected === red[red.length - 1]
                          ? 'red-card-selected'
                          : 'red-card'
                      "
                    >
                      <div v-for="student in red" :key="student.id">
                        {{ getName(student.name) }}
                      </div>
                    </div>
                  </td>
                  <td
                    style="font-weight: bold; font-size: 16px; color: #eb2d7c"
                  >
                    &nbsp;{{ red[red.length - 2] }}%
                  </td>
                </tr>
              </table>
            </div>

            <div class="red-to-yellow"></div>
            <div
              v-for="yellow in yellowPlags"
              :key="yellow.id"
              @click="select(yellow)"
            >
              <table>
                <tr>
                  <td>
                    <div
                      :class="
                        selected === yellow[yellow.length - 1]
                          ? 'yellow-card-selected'
                          : 'yellow-card'
                      "
                    >
                      <div
                        v-for="student in yellow"
                        :key="student.id"
                      >
                        {{ getName(student.name) }}
                      </div>
                    </div>
                  </td>
                  <td
                    style="font-weight: bold; font-size: 16px; color: #ffcc33"
                  >
                    &nbsp;{{ yellow[yellow.length - 2] }}%
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </td>
        <td style="width: 70%; vertical-align: top">
          <table
            v-if="submissions.length > 0 && getCurrentRT.enable_annonymous"
            @click="flipIdentityReveal()"
            style="margin-bottom: 15px"
          >
            <tr>
              <td>
                <div class="eye-container" style="cursor: pointer">
                  <i v-if="!hideNames" class="fa fa-eye" />
                  <i v-else class="fa fa-eye-slash" />
                </div>
              </td>
              <td>
                <span v-if="!hideNames">Hide Identities</span>
                <span v-else>Reveal Identities</span>
              </td>
            </tr>
          </table>

          <div
            v-for="submission in getSubmissions"
            :key="submission.id"
            class="plagiarism-submission-card"
          >
            <submission-card
              :key="submission.id"
              :submission="submission"
              :isInSummary="true"
              :isPlagPanel="true"
              :isAnonForPlagPanel="hideNames"
              :showVerticalDotMenu="false"
              style="margin-bottom: 30px"
            />
          </div>
        </td>
      </tr>
    </table>
    <div style="height: 30px" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SubmissionCard from '../../components/submissionCard/submissionCard';
import { EventBus } from 'utils/event-bus';

export default {
  name: 'roundtableSummaryPlagiarismScore',
  components: {
    SubmissionCard,
  },
  computed: {
    ...mapGetters(['getCurrentRT', 'getOrderedSubmissions']),
    getSubmissions() {
      let tracker = {};
      this.submissions.forEach((sub) => {
        tracker[sub] = sub;
      });

      let res = this.getOrderedSubmissions.filter((s) => tracker[s.id]) || [];
      if (res.length < 1) {
        return [];
      }

      res.sort((a, b) => {
        return (a.user_id < b.user_id) ? 1 : (a.user_id > b.user_id) ? -1 : 0;
      });

      return res;
    },
  },
  data() {
    return {
      redPlags: [],
      yellowPlags: [],
      selected: -1,
      submissions: [],
      hideNames: false,
      showBlank: false,
    };
  },
  methods: {
    getName(submission) {
      if (!submission) {
        return;
      }

      if (!this.hideNames) {
        return submission.user.name;
      }

      return submission.anonymous_identity.name;
    },
    select(item) {
      this.selected = item[item.length - 1];
      this.submissions = [];
      item.forEach((user) => {
        this.getOrderedSubmissions.forEach((sub) => {
          if (
            user.id === sub.user_id ||
            user.id === sub.anonymous_identity.id
          ) {
            this.submissions.push(sub.id);
          }
        });
      });
    },
    flipIdentityReveal() {
      EventBus.$emit('switchAnonymity');
      this.hideNames = !this.hideNames;
    },
    goToSubmission(event) {
      return this.$emit('goToSubmission', { submissionID: event });
    },
    initializePlagiarismScores() {
      this.$store.dispatch('getRoundtablePlagiarismScores').then(() => {
        this.hideNames = this.getCurrentRT.enable_annonymous;
        this.selected = 0;

        if (
          !this.getCurrentRT.plagiarism_scores ||
          this.getCurrentRT.plagiarism_scores.length < 1
        ) {
          if (this.getOrderedSubmissions.length > 1) {
            this.$store.dispatch(
              'plagiarismScoreGenerationForOlderRoundtables'
            );
          }
          this.showBlank = true;
          return;
        }

        try {
          const plag_scores = JSON.parse(this.getCurrentRT.plagiarism_scores);
          let users = {};

          this.getCurrentRT.submissions.forEach((sub) => {
            users[sub.user_id] = sub;
            users[sub.anonymous_identity_id] = sub;
          });

          Object.keys(plag_scores).forEach((score) => {
            Object.keys(plag_scores[score]).forEach((s) => {
              if (plag_scores[score][s] > 40) {
                if (s > score) {
                  this.redPlags.push([
                    { id: s, name: users[s] },
                    { id: score, name: users[score] },
                    plag_scores[score][s],
                    0,
                  ]);
                }
                else {
                  this.redPlags.push([
                    { id: score, name: users[score] },
                    { id: s, name: users[s] },
                    plag_scores[score][s],
                    0,
                  ]);
                }
              } else if (plag_scores[score][s] > 25) {
                if (s > score) {
                  this.yellowPlags.push([
                    { id: s, name: users[s] },
                    { id: score, name: users[score] },
                    plag_scores[score][s],
                    0,
                  ]);
                }
                else {
                  this.yellowPlags.push([
                    { id: score, name: users[score] },
                    { id: s, name: users[s] },
                    plag_scores[score][s],
                    0,
                  ]);
                }
              }
            });
          });

          for (let i = 0; i < this.redPlags.length; i++) {
            this.redPlags[i][3] = i;
          }

          let sub = this.redPlags[0] ? this.redPlags[0] : null;
          for (let i = 0; i < this.yellowPlags.length; i++) {
            this.yellowPlags[i][3] = i + this.redPlags.length;
          }

          if (sub === null) {
            sub = this.yellowPlags[0] ? this.yellowPlags[0] : null;
          }

          if (sub) {
            this.select(sub);
          } else {
            this.showBlank = true;
          }
        } catch (e) {
          console.log(e);
          this.showBlank = true;
        }
      });
    },
  },
  mounted() {
    this.initializePlagiarismScores();
  },
};
</script>

<style scoped>
.red-square {
  width: 15px;
  height: 15px;
  background: #eb2d7c;
}

.yellow-square {
  width: 15px;
  height: 15px;
  background: #ffcc33;
}

.red-card {
  transition: background-color 0.2s ease;
  border: 1px solid #eb2d7c;
  width: 215px;
  padding: 10px;
  text-align: start;
  border-radius: 4px;
  cursor: pointer;
}

.red-card-selected {
  transition: background-color 0.2s ease;
  border: 2px solid #eb2d7c;
  background: #ffeff5;
  font-weight: bold;
  width: 215px;
  padding: 10px;
  text-align: start;
  border-radius: 4px;
  cursor: pointer;
}

.red-card:hover {
  background: #ffeff5;
}

.yellow-card {
  transition: background-color 0.2s ease;
  border: 1px solid #ffcc33;
  width: 215px;
  padding: 10px;
  text-align: start;
  border-radius: 4px;
  cursor: pointer;
}

.yellow-card-selected {
  transition: background-color 0.2s ease;
  border: 2px solid #ffcc33;
  background: #fdf5d8;
  font-weight: bold;
  width: 215px;
  padding: 10px;
  text-align: start;
  border-radius: 4px;
  cursor: pointer;
}

.yellow-card:hover {
  background: #fdf5d8;
}

.red-to-yellow {
  height: 4px;
}

.eye-container {
  border: 1px solid #d6d4d4;
  border-radius: 5px;
  padding: 0 5px;
  width: 30px;
  margin-left: 45px;
}

.plagiarism-submission-card {
  width: 600px;
  min-width: 600px;
  max-width: 600px;
  margin-left: 20px;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// roundtableSummaryPlagiarismScore.vue?bc798912